// extracted by mini-css-extract-plugin
export default {"productNameInput":"P8hqnm29xtEf7kCxulX8","tagsField":"VnBUqSef_7Km0eUz3XGu"};